import { render, staticRenderFns } from "./SpecialCoinOfferImage.vue?vue&type=template&id=07d74850&"
import script from "./SpecialCoinOfferImage.vue?vue&type=script&lang=ts&"
export * from "./SpecialCoinOfferImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports